import {
  Box,
  Typography,
  Grid,
  IconButton,
  Skeleton,
  Divider,
} from '@mui/material';
import { DragIndicator, Edit } from '@mui/icons-material';

const GridTableList = ({
  data,
  stickyZIndex,
  onRowSelect,
  selectedId,
  selectedRowKey,
  sx,
  showActions = false,
  columns = [],
  showHeader = false,
}) => {
  // const columns = data?.metadata?.columns || [];
  const rows = data?.rows || [];
  const isLoading = !data;

  // const effectiveZIndex =
  // stickyZIndex !== undefined ? stickyZIndex : theme.zIndex.appBar + 1;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        mb: 4,
        p: 0,
        ...sx,
        zIndex: stickyZIndex !== undefined ? stickyZIndex : 'auto',
      }}
    >
      {/* Header */}
      {showHeader && Array.isArray(columns) && columns.length > 0 && (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            position: 'sticky',
            top: 0,
            zIndex: 2,
          }}
        >
          <Grid container sx={{ py: 1.5, px: 2 }}>
            {columns.map((col) => (
              <Grid
                item
                xs={col.width || 12}
                key={col.field}
                sx={{ minWidth: `${(col.width / 12) * 100}%` }}
              >
                <Typography
                  variant='body2'
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase', fontSize: '0.75rem' }}
                >
                  {col.label}
                </Typography>
              </Grid>
            ))}
            {showActions && <Grid item xs={2} />}
          </Grid>
        </Box>
      )}

      {/* Body */}
      <Box>
        {isLoading ? (
          <GridTableSkeleton columns={columns.length} />
        ) : rows.length ? (
          rows.map((row, idx) => (
            <GridTableRow
              key={row._id || idx}
              row={row}
              columns={columns}
              selected={selectedId === row[selectedRowKey || '_id']}
              onSelect={() => onRowSelect(row)}
              showActions={showActions}
            />
          ))
        ) : (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography color='text.secondary'>
              Нет связанных записей
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

// Строка таблицы
const GridTableRow = ({
  row,
  columns,
  selected,
  onSelect = () => {},
  showActions,
}) => (
  <Grid
    id={row._id}
    container
    sx={{
      py: 1.5,
      px: 2,
      borderBottom: 1,
      borderColor: 'divider',
      bgcolor: selected ? 'action.selected' : 'transparent',
      cursor: onSelect ? 'pointer' : 'default',
      '&:hover': { bgcolor: 'action.hover' },
      opacity: row.visible === false ? 0.6 : 1,
    }}
    onClick={onSelect}
  >
    {columns.map((col) => {
      if (col?.type === 'divider') {
        return (
          <Grid item xs={col.width || 12} key={col.field}>
            <Divider />
          </Grid>
        );
      }

      const value = col.field.split('.').reduce((obj, key) => obj?.[key], row);
      // console.log('col', col);
      // console.log('row', row);

      // console.log('value ', value);
      const isString = typeof value === 'string';
      if (!isString) {
        return <Grid item xs={col.width || 12} key={col.field}></Grid>;
      }

      return (
        <Grid item xs={col.width || 12} key={col.field}>
          <Typography
            variant={col?.variant || 'body1'}
            sx={{
              textDecoration:
                (row.visible === false || row.hidden === true)
                  ? 'line-through'
                  : col?.textDecoration || 'none',
              // fontWeight: 500,
              color: col?.color || 'text.primary',
            }}
          >
            {/* {row[col.field] || '-'} */}
            {isString ? value : typeof value}
          </Typography>
        </Grid>
      );
    })}

    {showActions && (
      <Grid item xs={2} sx={{ textAlign: 'right' }}>
        <IconButton size='small'>
          <DragIndicator fontSize='small' />
        </IconButton>
        <IconButton size='small'>
          <Edit fontSize='small' />
        </IconButton>
      </Grid>
    )}
  </Grid>
);

// Skeleton
const GridTableSkeleton = ({ columns = 2 }) => (
  <>
    {Array(5)
      .fill()
      .map((_, i) => (
        <Grid
          container
          sx={{ py: 1.5, px: 2, borderBottom: 1, borderColor: 'divider' }}
          key={i}
        >
          <Grid item xs={3}>
            <Skeleton width='80%' height={20} />
          </Grid>
          <Grid item xs={columns > 1 ? 6 : 9}>
            <Skeleton width='60%' height={20} />
          </Grid>
          {columns > 1 && (
            <Grid item xs={3}>
              <Skeleton width='40%' height={20} />
            </Grid>
          )}
        </Grid>
      ))}
  </>
);

export default GridTableList;
